import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'
// import vue from '/src/main'
import { DefaultRequest } from '@/../grpc/base_pb'
import { ManagerSignInRequest } from '@/../grpc/manager_pb'
import Vue from 'vue'

const getDefaultState = () => {
  return {
    token: getToken(),
    roles: [],
    name: '',
    avatar: ''
  }
}

const state = getDefaultState()
const vue = new Vue()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USERID: (state, userId) => {
    state.userId = userId
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    const roleArr = []
    roles.forEach(v => {
      roleArr.push(v.id)
    })
    state.roles = roleArr
  }
}

const actions = {
  // user login
  login({ commit }, object) {
    // eslint-disable-next-line no-undef
    // console.log('login: ', object)
    const { username, password, loginValid, picId } = object.params

    return new Promise((resolve, reject) => {
      const paraRequest = new ManagerSignInRequest()
      paraRequest.setUsercode(username)
      paraRequest.setPassword(password)
      paraRequest.setPiccode(loginValid)
      paraRequest.setPicid(picId)
      // debugger
      vue.client.managerSignIn(paraRequest, {}, (err, SignInReply) => {
        // console.log('login: ' + username + ' ' + password)
        if (err == null) {
          // console.log('getToken', SignInReply.getToken())
          const token = SignInReply.getToken()
          // console.log('SET_TOKEN: ', token)
          commit('SET_TOKEN', token)
          setToken(token)
          resolve()
        } else {
          const res = err
          // console.log('login error: ', res)
          vue.$message({
            message: res.message,
            type: 'error'
          })
          reject(res)
        }
      })
    })
  },

  getUserInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      const paraRequest = new DefaultRequest()

      vue.client.managerGetUserInfo(paraRequest, { Token: getToken() }, (err, StdRsReply) => {
        if (err == null) {
          const data = JSON.parse(StdRsReply.getJsonstr())

          commit('SET_USERID', data.id)
          commit('SET_NAME', data.username)
          commit('SET_ROLES', data.roles)
          commit('SET_AVATAR', 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif')
          resolve(data)
        } else {
          const res = err
          console.log('login error: ' + res)
          reject(res)
        }
      })
    })
  },

  getVueRoutes({ commit, state }) {
    return new Promise((resolve, reject) => {
      const paraRequest = new DefaultRequest()
      // todo 调用接口获取column
      vue.client.managerColumnQuery(paraRequest, { Token: state.token }, (err, StdRsReply) => {
        if (err == null) {
          const data = JSON.parse(StdRsReply.getJsonstr())
          resolve(data.rs)
        } else {
          console.log('error: ' + err)
          reject(err)
        }
      })
    })
  },
  // user logout
  logout({ commit, state }) {
    // return new Promise((resolve, reject) => {
    // user.logout(state.token).then(() => {
    removeToken() // must remove  token  first
    resetRouter()
    commit('RESET_STATE')
    // resolve()
    // }).catch(error => {
    //   reject(error)
    // })
    // })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

